import React, { useState, useEffect } from 'react'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts/highstock'
import { Card, Grid, Checkbox } from '@scuf/common'
import useDAPC from './useDAPC'

const TostacionDAPC = ({ height, getData }) => {
    const { checkT, fCalculateLenghtT, setCheckT, fCalculateEnabledDisabledT } = useDAPC(null)
    const [option, setOption] = useState(null)

    const categories = [
        'Tonelaje SC-202',
        'Flujo de aire',
        'Prom. Temp. Sup'
    ]

    const colors = ['#1792e5', '#7eb338', '#ffc627', '#f37021', '#ee3124', '#9b59b6', '#b65959', '#8dcdff', '#9e9e9e']

    useEffect(() => {

        if (getData && getData.length > 0) {
            let _labels = [], _data = [], band = 0, _height = 100 / fCalculateLenghtT(), top = 0

            for (let index = 0; index < categories.length; index++) {
                if (fCalculateEnabledDisabledT()[index] === 1) {
                    _data.push({
                        type: 'line',
                        name: categories[index],
                        data: getData.filter(n => n.Detalle === categories[index]).map((x, i) => [new Date(x.FechaHora).getTime(), x.Valor]),
                        yAxis: band,
                        color: colors[index],
                        gridLineWidth: 0
                    })
                    band = band + 1

                    _labels.push({
                        labels: {
                            align: 'right',
                            x: -3
                        },
                        title: {
                            text: categories[index]
                        },
                        height: _height + '%',
                        top: top + '%',
                        resize: {
                            enabled: true
                        },
                        gridLineWidth: 0,
                        offset: 0,
                    })

                    top = top + _height

                    if (fCalculateLenghtT() === band) {
                        setOption(
                            {
                                rangeSelector: { buttons: [] },
                                title: {
                                    text: ''
                                },
                                yAxis: _labels,

                                tooltip: {
                                    split: true
                                },
                                series: _data,
                                credits: {
                                    enabled: false
                                }
                            }
                        )
                    }
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkT])

    return (
        <>
            {console.log(option)}
            <Grid.Column width={10} sWidth={12} xsWidth={12} className='div-pe-0px-xs'>
                {
                    option && (checkT.btn1 || checkT.btn2 || checkT.btn3) ?
                        <div className='line-custom'>
                            <HighchartsReact
                                constructorType='stockChart'
                                style={{ width: '100%' }}
                                highcharts={Highcharts}
                                options={option}
                                containerProps={{ style: { height: height, width: '100%' } }}
                            />
                        </div>
                        :
                        <div className='letter-origin'>...No hay datos</div>
                }
            </Grid.Column>
            <Grid.Column width={2} sWidth={12} xsWidth={12} className='div-ps-0px-xs'>
                <Card className='m-0 p-0'>
                    <Card.Header>
                        <div className='letter-origin mb-2'>VARIABLES</div>
                    </Card.Header>
                    <Grid.Row>
                        <div className='mx-2'>
                            <Checkbox label="Seleccionar Todo" toggle={true} checked={checkT.btn1 && checkT.btn2 && checkT.btn3 ? true : false}
                                onChange={(checked) =>
                                    checked ?
                                        setCheckT({ btn1: true, btn2: true, btn3: true })
                                        :
                                        setCheckT({ btn1: false, btn2: false, btn3: false })
                                }
                            />
                            <Checkbox label="Tonelaje SC-202" onChange={(checked) => { setCheckT({ ...checkT, btn1: checked }) }} checked={checkT.btn1} />
                            <Checkbox label="Flujo de aire" onChange={(checked) => setCheckT({ ...checkT, btn2: checked })} checked={checkT.btn2} />
                            <Checkbox label="Promedio temperatura superior" onChange={(checked) => setCheckT({ ...checkT, btn3: checked })} checked={checkT.btn3} />
                        </div>
                    </Grid.Row>
                </Card>
            </Grid.Column>
        </>
    )
}

export default TostacionDAPC